import { FC } from 'react';
import styles from './MainContentPlaceholder.module.scss';
import JoyLoader from '../JoyLoader';

const MainContentPlaceholder: FC = () => (
  <div className={styles.root}>
    <JoyLoader />
  </div>
);

export default MainContentPlaceholder;
